import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'item',
} as IModuleProps;
